<template>
  <div class="wrapper">
    <!-- <h1 class="title">
      {{ $prismic.richTextAsPlain(fields.roxane_intro) }}
    </h1> -->
    <div class="intro-container">
      <div class="pic">
        <div class="intro-picture" :style="{backgroundImage: `url(${fields.photo.url}`}"></div>
        <p style="text-align: center; color: #655F49; opacity: .8; font-size: .6em">its72b1</p>
      </div>
      <prismic-rich-text :field="fields.roxane_intro" class="intro-description" />
    </div>
    <Slideshow :metadescr="fields.metakinebiologie_description" :accessdescr="fields.access_bars_description" />
    <div class="mes-formations">
      <h3 class="title">Mon parcours (non-exhaustif) de ces dernières années :</h3>
      <ul>
        <li class="formation" v-for="(formation, i) in fields.parcours" :key="i">
          {{ formation.titre_formation[0].text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Slideshow from '@/components/Slideshow.vue';

export default {
  name: 'Home',
  components: {
    Slideshow
  },
  data () {
    return {
      fields: {
        roxane_intro: null,
        metakinebiologie_description: null,
        access_bars_description: null,
        parcours: [],
        photo: null
      }
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getSingle('accueil')
          .then((document) => {
            this.fields.roxane_intro = document.data.roxane_intro;
            this.fields.metakinebiologie_description = document.data.metakinebiologie_description;
            this.fields.access_bars_description = document.data.access_bars_description;
            this.fields.parcours = document.data.parcours;
            this.fields.photo = document.data.photo;
            console.log(this.fields.metakinebiologie_description);
          })
    }
  },
  created () {
    this.getContent();
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent()
    next()
  }
}
</script>

<style>
.wrapper {
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  padding: 40px 10px;
}

.intro-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.intro-picture {
  margin-top: 2em;
  min-width: 200px!important;
  min-height: 250px;
  background-position: center;
  border-radius: 50%;
}

.pic {
  margin-right: 2em;
}


.intro-description {
  margin-left: 2em;
  text-align: right;
  width: 50%;
  font-size: 1.2em;
  color: #655F49;
}

.mes-formations > .formation {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.mes-formations > .formation > img {
  width: 25px;
  margin: 20px;
}

.formation {
  font-size: 1.2em;
}

.mes-formations {
  color: #655F49;
  font-family: 'Quintessential', cursive;
}

.mes-formations > .title {
  text-align: center;
  font-weight: normal;
  font-size: 1.5em;
  margin-bottom: 2em;
}

@media screen and (max-width: 900px) {

  .wrapper {
    margin-top: 2em;
    padding: 40px 10px;
  }

  .intro-container {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }

  .intro-picture {
    margin: 0;
  }

  .intro-description {
    margin-bottom: 3em;
    text-align: center;
    margin-left: 0;
    width: 80%;
  }
}
</style>